// Branded import settings
import browserUpdateOpts from './branded/dl/_browser-update-options';
import cookieConsentOpts from './branded/dl/_cookieconsent-options';
import historyOpts from './branded/dl/_history-options';
import scrollTrackingOpts from './branded/dl/_scroll-tracking-options';
import { resultsOpts, homeOpts, selectOpts } from './branded/dl/_search-options';
import tourOpts from './branded/dl/_tour-options';

// Common imports
import browserUpdate from './common/_browser-update';
import cookieConsent from './common/_cookieconsent';
import * as effects from './common/_effects';
import * as history from './common/_history';
// import imgControls from './common/_img-controls';
import * as metaData from './common/_ark';
import scrollTracking from './common/_scroll-tracking';
import * as search from './common/_search-form';
import * as stats from './common/_stats';
import * as tour from './common/_tour';
import * as utils from './common/_util';

browserUpdate.initBrowserUpdate(browserUpdateOpts);

cookieConsent.initCookieConsent(cookieConsentOpts);

effects.revealButtons();
effects.scrollz();
effects.doTooltips();
effects.doPopovers();
effects.prettyDropdowns();
effects.dropdownRemovesTip();
effects.animateSearchIcon();
effects.showThumbnailMeta();
effects.scrollToListJSResults();
effects.createRandomHomepageFeature();
effects.toggleDrawer();
effects.whatsNew();

history.setArkHistory();
history.getArkHistory(historyOpts);
history.setSearchResultScrollPosition();

// imgControls.runImageManipulator();

metaData.dateModal();
metaData.toggleArkNavElements();
metaData.jumpControl();
metaData.equalizeThumbnailHeight();
metaData.toggleHighlighting();
metaData.toggleHighlightingColor();
metaData.buildSearchResults();
metaData.arkSearchAlternates();
metaData.arkKeyBindings();
metaData.arkEmptySearchFocus();

scrollTracking.initScrollTracking(document, window, scrollTrackingOpts);

search.searchSelector(resultsOpts);
search.searchSelector(homeOpts);
search.searchSelector(selectOpts);
search.getSearchTypeDefault();
search.setSearchTypeDefault();
// search.focusOnSearchInput();
// search.makeSampleSearches();
search.orderBlankSearches();
search.buildAdvancedSearch();
search.focusHeaderSearch();

window.Charts = {};
window.Charts.renderInView = stats.renderInView;
stats.bindResize();

tour.quickSearchExplanation(tourOpts);
// tour.alertFacetsExplanation();
tour.tourScrollSpy();
tour.tourReset();
tour.activeCurrentTourLink();

utils.printPage();
utils.copyText();
utils.createAnchors();
utils.toggleColumns();
utils.addPagination();
utils.hideAlerts();
utils.hideAppealMessages();
